import React, { Component } from 'react'
import { Button, Col, Form, Icon, Input, Upload } from 'antd'
import { compose } from 'recompose'
import { get } from 'lodash'

class SalikForm extends Component {
  render() {
    const { onFileLoaded, csvFileList, salikUploadList, beforeUpload } = this.props
    const { getFieldDecorator } = this.props.form
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 14, offset: 1 },
      },
    }
    const props = {
      onChange: onFileLoaded,
      beforeUpload: beforeUpload,
      fileList: csvFileList,
    }
    return (
      <Form>
        <Col span={12}>
          <Form.Item {...formItemLayout} label={'Account'}>
            {getFieldDecorator('account', {
              rules: [{ required: true, message: 'Account!' }],
            })(<Input placeholder={'Account'} />)}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item {...formItemLayout} label={'File'}>
            {getFieldDecorator('file', {
              rules: [{ required: true, message: 'Please Select a File!' }],
            })(
              <Upload {...props}>
                <Button>
                  <Icon type="upload" /> Select File
                </Button>
              </Upload>
            )}
            {salikUploadList.length > 0 && <span>{`Records to be uploaded ${salikUploadList.length}`}</span>}
          </Form.Item>
        </Col>
      </Form>
    )
  }
}

SalikForm.propTypes = {}
SalikForm.defaultProps = {}

export default compose(Form.create())(SalikForm)
